'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _ProfileFirstName = require('../Profile/ProfileFirstName');

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _Link = require('../Core/Link');

var _Link2 = _interopRequireDefault(_Link);

var _ArrowIcon = require('../Icon/ArrowIcon');

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _ChevronIcon = require('../Icon/ChevronIcon');

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules() {
  return {
    wrapper: {
      width: '100%',
      boxSizing: 'border-box',
      display: 'block',
      padding: '16px',
      desktop: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '24px',
        '& > *:last-child': {
          marginBottom: '0'
        }
      }
    },
    profileName: {
      display: 'block',
      width: '100%',
      marginBottom: '30px',
      fontSize: '18px',
      textAlign: 'left',
      color: '#666',
      desktop: {
        display: 'none'
      }
    },
    navLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: '56px',
      padding: '0 16px',
      color: '#666',
      position: 'relative',
      fontSize: '14px',
      textAlign: 'left',
      borderTop: '1px solid #e0e0e0',
      transition: 'opacity 0.2s ease-in-out',
      willChange: 'opacity',
      ':hover': {
        color: '#666666',
        opacity: '0.75',
        textDecoration: 'none'
      },
      desktop: {
        height: 'auto',
        width: '200px',
        justifyContent: 'flex-start',
        padding: '6px 0',
        marginBottom: '12px',
        border: 'none'
      }
    },
    navLinkChevronIcon: {
      marginRight: '10px'
    }
  };
};

var HeaderProfileNav = function HeaderProfileNav(props) {
  var mobile = props.mobile,
      profile = props.profile,
      config = props.config,
      heimdall = props.heimdall,
      styles = props.styles,
      onClickLink = props.onClickLink;


  return (0, _preact.h)(
    'div',
    { className: styles.wrapper },
    (0, _preact.h)(
      'span',
      { className: styles.profileName },
      (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
    ),
    heimdall.profiles.map(function (profile) {
      return (0, _preact.h)(
        _Link2.default,
        _extends({ key: profile.key, href: profile.path, onClick: onClickLink(profile), title: profile.label, className: styles.navLink }, (0, _utils.getAttrsGtm)(profile.label, { clicktype: 'submenu' })),
        [!mobile && (0, _preact.h)(_ChevronIcon2.default, { placement: 'left', className: styles.navLinkChevronIcon }), profile.label, mobile && (0, _preact.h)(_ArrowIcon2.default, { color: config.color })]
      );
    })
  );
};

exports.default = (0, _preactFela.connect)(rules)(HeaderProfileNav);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderProfileNav.js
// module id = 203
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38